(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["LunaMarquee"] && !Shopify.designMode) return;
  try {
    
  if(typeof LunaMarqueeSwiper !== 'function') {
    class LunaMarqueeSwiper extends HTMLElement {
      constructor() {
        super();
        this.slider = this.querySelector('.swiper');
        this.settings = {
          speed: parseInt(this.dataset.speed),
          autoplay: {
            disableOnInteraction: false,
            delay: 100
          },
          on: {
            init: () => {
              this.querySelector('.swiper-wrapper').style.opacity = 1;
            },
          },
          centeredSlides: true,
          freeMode: true,
          loop: true,
          loopedSlides: Math.max(parseInt(this.dataset.mobile), parseInt(this.dataset.size)),
          slidesPerView: parseInt(this.dataset.mobile),
          spaceBetween: parseInt(this.dataset.spaceBetween),
          breakpoints: {
            750: {
              loopedSlides: Math.max(parseInt(this.dataset.tablet), parseInt(this.dataset.size)),
              slidesPerView: parseInt(this.dataset.tablet)
            },
            1250: {
              loopedSlides: Math.max(parseInt(this.dataset.desc), parseInt(this.dataset.size)),
              slidesPerView: parseInt(this.dataset.desc)
            },
            1800: {
              loopedSlides: Math.max(parseInt(this.dataset.desc) + 2, parseInt(this.dataset.size)),
              slidesPerView: parseInt(this.dataset.desc) + 2
            }
          }
        };
        this.swipper;

        this.init();
        document.addEventListener("shopify:section:load", (event) => {
          this.appendAssets();
          this.init();
        });

        window.addEventListener('resize', () => {
          setTimeout(() => {
            this.swipper.update();
            this.swipper.slideToLoop(this.swipper.realIndex, 0);
          }, 300);
        })
      }
      appendAssets() {
        const link = document.createElement('link');
        const script = document.createElement('script');

        link.rel = 'stylesheet';
        link.href = 'https://cdn.jsdelivr.net/npm/swiper@8/swiper-bundle.min.css';
        script.src = 'https://cdn.jsdelivr.net/npm/swiper@8/swiper-bundle.min.js';

        document.head.appendChild(link);
        document.body.appendChild(script);
      }
      init() {
        if (typeof Swiper !== 'function') {
          this.appendAssets();
          this.swiperChecker();
        } else {
          this.initSlider();
        }
      }
      initSlider() {
        if (this.swipper && this.swipper.destroy) {
          this.swipper.destroy();
          this.swipper = null;

          this.swipper = new Swiper(this.slider, this.settings);
        } else {
          this.swipper = new Swiper(this.slider, this.settings);
        }
      }
      swiperChecker() {
        const interval = setInterval(() => {
          if (typeof Swiper !== 'function') {
            this.swiperChecker();
          } else {
            clearInterval(interval);
            this.initSlider();
          }
        }, 100);
      }
    }
    customElements.define('luna-marquee-swiper', LunaMarqueeSwiper);
  };

  } catch(e) { console.error(e); }
})();
})();
